import { parse } from 'graphql'

/**
 * Cart and cart line types returned by the IT Management Marketplace cell service.
 * Schema uses camelCase (GraphQL-Ruby default).
 */
export interface MarketplaceCartLine {
  id: string
  productId: string
  productVariantId: string
  productOfferId: string
  quantity: number
  unitPrice: string
}

export interface MarketplaceCart {
  id: string
  companyId: string
  customerId: string
  price: string | null
  cartLines: MarketplaceCartLine[]
}

export const GET_MARKETPLACE_CART = parse(`
  query GetMarketplaceCart($id: String!) {
    cart(id: $id) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const CREATE_MARKETPLACE_CART = parse(`
  mutation CreateMarketplaceCart {
    createCart {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const ADD_MARKETPLACE_CART_LINE = parse(`
  mutation AddMarketplaceCartLine(
    $cartId: String!
    $productId: String!
    $productVariantId: String!
    $productOfferId: String!
    $quantity: Int!
    $unitPrice: Float!
  ) {
    addCartLine(
      cartId: $cartId
      productId: $productId
      productVariantId: $productVariantId
      productOfferId: $productOfferId
      quantity: $quantity
      unitPrice: $unitPrice
    ) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const UPDATE_MARKETPLACE_CART_LINE = parse(`
  mutation UpdateMarketplaceCartLine(
    $cartLineId: String!
    $quantity: Int!
  ) {
    updateCartLine(cartLineId: $cartLineId, quantity: $quantity) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const REMOVE_MARKETPLACE_CART_LINE = parse(`
  mutation RemoveMarketplaceCartLine($cartLineId: String!) {
    removeCartLine(cartLineId: $cartLineId) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)
